import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PageHeaderComponent {
  @Input() title = '';
  @Input() description?: string;
  @Input() icon?: string;
  @Input() headerClass = '';
}
